const PAGE_WIDTH = 756
const INSET_MAX_DISPLAY_HEIGHT = 150
const INSET_RENDER_SCALE_DIVISOR = 5

const roundUpToNearestTen = (value) => Math.ceil(value / 10) * 10

// The portrait check only needs aspect ratio, so a small probe is enough.
export const BROCHURE_ORIENTATION_PROBE_WIDTH = roundUpToNearestTen(
  PAGE_WIDTH / 3
)

// The no-scheme hero image spans the main page width and needs extra print headroom.
export const BROCHURE_MAIN_NO_SCHEME_WIDTH = roundUpToNearestTen(
  PAGE_WIDTH * 1.5
)

// The inset height is derived from naturalHeight / 5, so the fetched image still
// needs enough pixel height to reach the existing 150px cap for common wide photos.
export const BROCHURE_INSET_IMAGE_WIDTH = roundUpToNearestTen(
  INSET_MAX_DISPLAY_HEIGHT * INSET_RENDER_SCALE_DIVISOR * 2
)
